import { List, Map } from 'immutable';

export default Map({
  list: Map({
    loading: false,
    error: null,
    data: Map(),
  }),
  action: Map({
    loading: false,
    error: null,
  }),
  active: Map({
    loading: false,
    error: null,
    data: List(),
  }),
});
